import React, { useState, useEffect } from "react";
import { TextField, Button, Card, CardContent, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";

function EditBill({ row }) {
  const [billData, setBillData] = useState(row);

  useEffect(() => {
    setBillData(row);
  }, [row]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBillData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    console.log("Updated Bill Data:", billData);
    alert("Bill details saved successfully!");
  };

  return (
    <Card variant="outlined" sx={{ padding: 2, marginTop: 2 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Edit Bill: {billData.bill}
        </Typography>
        <Grid2 container spacing={2}>
          <Grid2 size={6}>
            <TextField
              fullWidth
              label="Bill ID"
              variant="outlined"
              name="bill"
              value={billData.bill}
              disabled
            />
          </Grid2>
          <Grid2 size={6}>
            <TextField
              fullWidth
              label="Visit"
              variant="outlined"
              name="visit"
              value={billData.visit}
              disabled
            />
          </Grid2>
          <Grid2 size={6}>
            <TextField
              fullWidth
              label="Patient Name"
              variant="outlined"
              name="patientName"
              value={billData.patientName}
              disabled
            />
          </Grid2>
          <Grid2 size={6}>
            <TextField
              fullWidth
              label="Generated By"
              variant="outlined"
              name="generatedBy"
              value={billData.generatedBy}
              disabled
            />
          </Grid2>
          <Grid2 size={6}>
            <TextField
              fullWidth
              label="Bill Status"
              variant="outlined"
              name="billStatus"
              value={billData.billStatus}
              onChange={handleChange}
            />
          </Grid2>
          <Grid2 size={6}>
            <TextField
              fullWidth
              label="Total Amount"
              variant="outlined"
              name="totalAmount"
              value={billData.totalAmount}
              onChange={handleChange}
            />
          </Grid2>
          <Grid2 size={6}>
            <TextField
              fullWidth
              label="Total Payment"
              variant="outlined"
              name="totalPayment"
              value={billData.totalPayment}
              onChange={handleChange}
            />
          </Grid2>
          <Grid2 size={6}>
            <TextField
              fullWidth
              label="Total Balance"
              variant="outlined"
              name="totalBalance"
              value={billData.totalBalance}
              disabled
            />
          </Grid2>
          <Grid2 size={12} display="flex" justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={handleSave}>
              Save
            </Button>
          </Grid2>
        </Grid2>
      </CardContent>
    </Card>
  );
}

export default EditBill;
